<template>
    <div :class="{transport:!isMobile,mtransport:isMobile,mobileCommon:isMobile}">
        <div class="opt">
            <p class="SubTitle title">{{ langPage['v4-confirmation']['TXT_verifiezvotrecommande'] }}</p>
            <el-button v-if="$store.state.order_confirm.pay_type=='thirdPay'"
                       :loading="loading" @click="sub">{{
                    langPage['v4-confirmation']['TXT_valideretproceder']
                }}
            </el-button>
            <!--转账支付的时候提示是否确认-->
            <el-popconfirm
                v-else
                :title="langPage['panier-resume']['TXT_virementbancaireevs']"
                :confirm-button-text="langPage['pages-support']['TXT_oui']"
                :cancel-button-text="langPage['pages-support']['TXT_non']"
                @confirm="sub">
                <el-button :loading="loading" slot="reference">{{
                        langPage['v4-confirmation']['TXT_valideretproceder']
                    }}
                </el-button>
            </el-popconfirm>
        </div>

        <div class="main flex">
            <paiement/>
        </div>
        <div class="main flex">
            <div>
                <div class="space">
                    <p class="SubTitle">{{ langPage['compte-popup-adresse']['TXT_adresselivraison'] }}</p>
                </div>
                <addCarte :width="isMobile?'75':'5'" :bg="true" :msg="livraison" :carteTitle="from"></addCarte>
                <!--                <chooseCarte :tipsbool="true" ref="one" :fromlist="from" :msg="livraison" :address-type="1"-->
                <!--                             @chooseAddress="()=>{}"></chooseCarte>-->
            </div>
            <div>
                <div class="space">
                    <p class="SubTitle">{{ langPage['compte-inscription']['TXT_adressefacturation'] }}</p>
                </div>
                <addCarte :width="isMobile?'75':'5'" :bg="true" :msg="facturation" :carteTitle="from"></addCarte>
            </div>
        </div>

        <div class="main flex">
            <div>
                <div class="space">
                    <p class="SubTitle">{{ langPage['v4-confirmation']['TXT_transport'] }}</p>
                </div>
                <div v-if="livraisonType===1">{{
                        `${order_confirm.deliver.is_group ? 'transporteur:groupage-' : 'transporteur:'}` + order_confirm.deliver.libelle
                    }}
                </div>
                <div v-if="livraisonType===2">Retrait direct chez fournisseurs</div>
                <div class="logistics" v-if="is_show_transport">
                    <div class="item bg">
                        <img class="img" :src="getDeliverLogo(order_confirm.deliver)" alt/>
                        <span class="deliverName">{{ getDeliverName(order_confirm.deliver) }} {{
                                langPage['v4-confirmation']['TXT_parefashion']
                            }}</span>
                        <span class="price">
                            {{
                                order_confirm.deliver.prix > order_confirm.deliver.prix_remise && order_confirm.deliver.prix_remise
                                    ? order_confirm.deliver.prix_remise : order_confirm.deliver.prix
                            }}€ HT</span>
                        <span>{{ langPage['v4-confirmation']['TXT_delaidelivraison'] }}</span>
                        <span>{{ langPage['panierv2-transporteur-efashion']['TXT_informations'] }}</span>
                    </div>
                </div>
                <!-- <addCarte width="4.15" :bg="true" :msg="addrdata" :carteTitle="addrfrom"></addCarte> -->
            </div>
            <div>
                <div class="space">
                    <!--          <p class="SubTitle">Paiement</p>-->
                    <!--          <span>Modifier</span>-->
                </div>
                <addCarte
                    width="4.15"
                    height="2.4"
                    genre="1"
                    :bg="true"
                    :msg="addrdata"
                    :carteTitle="addrfrom"
                ></addCarte>
            </div>
        </div>

        <div class="main commande">
            <div class="title SubTitle">
                <span>{{ langPage['v4-confirmation']['TXT_Commande'] }}</span>
                <!--                <p style="cursor: pointer" @click="$router.replace('/panier')">Modifier mon panier</p>-->
            </div>
            <tableCard ref="vTableCard"></tableCard>


        </div>
        <div class="opt a">
            <p></p>
            <div>
                <p>{{ langPage['v4-confirmation']['TXT_parvotrecommande'] }}</p>
                <el-button @click="sub" :loading="loading">{{
                        langPage['v4-confirmation']['TXT_valideretproceder']
                    }}
                </el-button>
            </div>
        </div>
        <bottom-nav/>
    </div>
</template>
<script>
// import
import addCarte from "../../components/addCarte";
import tableCard from "./confirmation/tableCard";
import BottomNav from "@/components/bottomNav";
import ChooseCarte from "@/views/Checkout/transport/chooseCarte";
import paiement from "@/views/Checkout/paiement";


let transportHelper = require('@/utils/helper/Checkout/transport_helper');
let commonUtils = require('@/utils/common_utils');
export default {
    name: "transport",
    components: {
        ChooseCarte,
        BottomNav,
        addCarte,
        tableCard,
        paiement
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            checked: true,
            autreActive: false,
            autreval: [
                "Je préfère organiser mon transport NEW",
                " J’enlève directement la marchandise"
            ],
            addrfrom: [
                {
                    title: "Numéro de carte ",
                    key: "a",
                    only: "true"
                },
                {
                    title: "Titulaire de la carte",
                    only: "true",
                    key: "b"
                },
                {
                    title: "Date d’expiration",
                    key: "c",
                    only: true
                },
                {
                    title: "Code de sécurité (CCV)",
                    key: "d",
                    // only: true
                    hidden: true
                }
            ],
            from: [
                {
                    title: this.$store.state.langPage['compte-popup-adresse']['TXT_nomcontact'],
                    key: "NomContact",
                },
                {
                    title: this.$store.state.langPage['panier-adresse']['TXT_societe'],
                    key: "Societe",
                },
                {
                    title: this.$store.state.langPage['compte-informations-popup-adresse']['TXT_adresse'],
                    key: "adresse",
                },
                {
                    title: this.$store.state.langPage['compte-informations-popup-adresse']['TXT_telephone'],
                    key: "telephone",
                },
                {
                    title: this.$store.state.langPage['compte-informations-popup-adresse']['TXT_mobile'],
                    key: "mobile",
                },
                {
                    title: this.$store.state.langPage['v4-topmenu']['TXT_payname'],
                    key: "pay_name",
                    onlyShow: true
                }
            ],
            addrdata: [],
            order_confirm: {deliver: {}},
            livraison: [],
            facturation: [],
            loading: false,
            is_show_transport: true,
            livraisonType: 0,
        };
    },
    mounted() {
        this.$store.commit("set", {key: "stepData", value: 1});
        this.order_confirm = this.$store.state.order_confirm;
        this.$forceUpdate();
        console.log('order_confirm', this.order_confirm);
        this.addrdata = [];
        this.livraison.push(this.order_confirm.livraison);
        this.facturation.push(this.order_confirm.facturation);
        console.log('order_confirm', this.order_confirm);
        this.is_show_transport = [0].includes(this.order_confirm.livraisonType);
        this.livraisonType = this.order_confirm.livraisonType;
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    },
    methods: {
        sub() {

            // {req_montant_total":116.48, 最后⽀付总⾦额（含税ttc价格）
            //     "id_livraison": 10, 物流id
            //     "id_adresse_livraison": 67749,送货地址id
            //     "id_adresse_facturation": 104638,发票地址id
            //     "groupage": 0,是否为团发
            //     "codes_promos": [] 打折码 （物流/订单打折码/平台打折码）
            // }
            let params = {};
            params.req_montant_total = this.order_confirm.totalNum.totalTtcTotals;
            if (this.order_confirm.livraisonType === 0) {
                params.id_livraison = this.order_confirm.deliver.id_livraison;
            } else if (this.order_confirm.livraisonType === 1) {
                params.id_livraison = this.order_confirm.deliver.id_livraison;
            } else if (this.order_confirm.livraisonType === 2) {
                params.id_livraison = 2;
            }


            params.id_adresse_livraison = this.order_confirm.livraison.id_adresse;
            params.id_adresse_facturation = this.order_confirm.facturation.id_adresse;
            params.groupage = params.id_livraison === 19 || (this.order_confirm.deliver && this.order_confirm.deliver.is_group) ? 1 : 0;
            params.codes_promos = [];
            params.pay_type = this.order_confirm.pay_type;
            params.date_expedition = this.order_confirm.dateExpedition;

            if (!commonUtils.isEmpty(this.$store.state.queryRemiseCode)) {
                params.codes_promos.push(this.$store.state.queryRemiseCode.id_remise);
            }
            params.codes_promos = params.codes_promos.join(',');
            let tableCardRemiseCode = this.$refs['vTableCard'].RemiseCode;
            let commandes_remises = JSON.parse(JSON.stringify(this.$store.state.commandes_remises));
            commandes_remises.push(tableCardRemiseCode);
            params.commandes_remises = JSON.stringify(commandes_remises);

            console.log('pay_params', params);
            this.loading = true;
            try {
                this.$api.order.pay(params).then(res => {
                    if (res.code === 0 && res.data && res.data.data && res.data.data.url) {
                        let url = res.data.data.url;
                        if (params.pay_type=='thirdPay_v3'){
                            url = `/payGreenV3?objectSecret=${res.data.data.object_secret}&paymentOrderID=${res.data.data.id}`;
                        }
                        window.location.href = url;
                    } else {
                        this.$message.error(res.message);
                        this.loading = false;
                        if (res.code == 2) {//价格不对，跳转回购物车页面
                            setTimeout(function () {
                                window.location.href = '/panier';
                            }, 2000)
                        }
                    }
                })
            } catch (e) {
                this.loading = false;
            }
        },
        moyens() {
            this.autreActive = !this.autreActive;
        },
        //获取物流公司logo
        getDeliverLogo(item) {
            return transportHelper.getDeliverLogo(item);
        },
        //获取物流公司名字
        getDeliverName(item) {
            return transportHelper.getDeliverName(item);
        },
        //当点击了地址的修改，跳转到地址页面
        onClickAddressModify() {
            this.$router.replace({name: "Adresses-transport"});
        }
    }
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Checkout/Confirmation.less">
</style>
